(function($) {
    $(document).ready(function() {
        // Otwieranie modala
        $('.open-modal').on('click', function() {
            var modalId = $(this).data('modal-id');
            $('#' + modalId).fadeIn();
        });
    
        // Zamykanie modala po kliknięciu na "x"
        $('.close').on('click', function() {
            var modalId = $(this).data('modal-id');
            $('#' + modalId).fadeOut();
        });
    
        // Zamykanie modala po kliknięciu na obszar poza modalem
        $(window).on('click', function(event) {
            if ($(event.target).hasClass('modal')) {
                $(event.target).fadeOut();
            }
        });

        var trainingModal = document.getElementById('training-modal');
        var titleNode = trainingModal ? trainingModal.querySelector('#training-modal-title') : null;
        var metaNode = trainingModal ? trainingModal.querySelector('.js-training-modal-meta') : null;
        var descriptionNode = trainingModal ? trainingModal.querySelector('.js-training-modal-description') : null;
        var cf7NameField = trainingModal ? trainingModal.querySelector('.js-training-name-field') : null;
        var trainingsListing = document.querySelector('.js-trainings-listing');
        var trainingFilterButtons = Array.from(document.querySelectorAll('.js-training-filter'));
        var trainingFiltersContainer = document.querySelector('.page-trainings__filters');
        var trainingsRequestController = null;
        var isTrainingFiltersPointerDown = false;
        var isTrainingFiltersDragging = false;
        var suppressTrainingFilterClick = false;
        var trainingFiltersDragStartX = 0;
        var trainingFiltersStartScrollLeft = 0;

        function openTrainingModal(trigger) {
            if (!trainingModal) {
                return;
            }

            var title = trigger.getAttribute('data-training-title') || '';
            var description = trigger.getAttribute('data-training-description') || '';
            var duration = trigger.getAttribute('data-training-duration') || '';
            var date = trigger.getAttribute('data-training-date') || '';
            var location = trigger.getAttribute('data-training-location') || '';
            var metaParts = [duration, date, location].filter(Boolean);

            if (titleNode) {
                titleNode.textContent = title;
            }

            if (metaNode) {
                metaNode.textContent = metaParts.join(' | ');
                metaNode.hidden = metaParts.length === 0;
            }

            if (descriptionNode) {
                descriptionNode.innerHTML = description ? '<p>' + description.replace(/\n+/g, '</p><p>') + '</p>' : '';
            }

            if (cf7NameField) {
                cf7NameField.value = title;
            }

            trainingModal.hidden = false;
            trainingModal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('training-modal-open');
        }

        function closeTrainingModal() {
            if (!trainingModal) {
                return;
            }

            trainingModal.hidden = true;
            trainingModal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('training-modal-open');
        }

        function getTrainingsState() {
            if (!trainingsListing) {
                return {
                    page: 1,
                    category: 'all',
                    baseUrl: window.location.href
                };
            }

            return {
                page: parseInt(trainingsListing.getAttribute('data-training-page') || '1', 10) || 1,
                category: trainingsListing.getAttribute('data-training-category') || 'all',
                baseUrl: trainingsListing.getAttribute('data-trainings-url') || window.location.href
            };
        }

        function updateTrainingFilters(selectedFilter) {
            trainingFilterButtons.forEach(function(button) {
                var isActive = button.getAttribute('data-training-filter') === selectedFilter;

                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });

            window.requestAnimationFrame(function() {
                centerActiveTrainingFilter('smooth');
            });
        }

        function centerActiveTrainingFilter(scrollBehavior) {
            if (!trainingFiltersContainer || window.innerWidth > 767) {
                return;
            }

            var activeFilter = trainingFiltersContainer.querySelector('.js-training-filter.is-active');

            if (!activeFilter || trainingFiltersContainer.scrollWidth <= trainingFiltersContainer.clientWidth) {
                return;
            }

            var maxScrollLeft = trainingFiltersContainer.scrollWidth - trainingFiltersContainer.clientWidth;
            var targetScrollLeft = activeFilter.offsetLeft - ((trainingFiltersContainer.clientWidth - activeFilter.offsetWidth) / 2);
            var boundedScrollLeft = Math.min(Math.max(targetScrollLeft, 0), maxScrollLeft);

            trainingFiltersContainer.scrollTo({
                left: boundedScrollLeft,
                behavior: scrollBehavior || 'auto'
            });
        }

        function initTrainingFiltersInteraction() {
            if (!trainingFiltersContainer) {
                return;
            }

            trainingFiltersContainer.addEventListener('wheel', function(event) {
                if (window.innerWidth > 767 || trainingFiltersContainer.scrollWidth <= trainingFiltersContainer.clientWidth) {
                    return;
                }

                var horizontalDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY)
                    ? event.deltaX
                    : event.deltaY;

                if (!horizontalDelta) {
                    return;
                }

                event.preventDefault();
                trainingFiltersContainer.scrollBy({
                    left: horizontalDelta,
                    behavior: 'auto'
                });
            }, { passive: false });

            trainingFiltersContainer.addEventListener('mousedown', function(event) {
                if (event.button !== 0 || window.innerWidth > 767 || trainingFiltersContainer.scrollWidth <= trainingFiltersContainer.clientWidth) {
                    return;
                }

                isTrainingFiltersPointerDown = true;
                isTrainingFiltersDragging = false;
                suppressTrainingFilterClick = false;
                trainingFiltersDragStartX = event.clientX;
                trainingFiltersStartScrollLeft = trainingFiltersContainer.scrollLeft;
                trainingFiltersContainer.classList.add('is-dragging');
            });

            trainingFiltersContainer.addEventListener('mousemove', function(event) {
                var deltaX = event.clientX - trainingFiltersDragStartX;

                if (!isTrainingFiltersPointerDown) {
                    return;
                }

                if (Math.abs(deltaX) > 6) {
                    isTrainingFiltersDragging = true;
                    suppressTrainingFilterClick = true;
                }

                if (!isTrainingFiltersDragging) {
                    return;
                }

                event.preventDefault();
                trainingFiltersContainer.scrollLeft = trainingFiltersStartScrollLeft - deltaX;
            });

            trainingFiltersContainer.addEventListener('click', function(event) {
                if (!suppressTrainingFilterClick) {
                    return;
                }

                suppressTrainingFilterClick = false;
                event.preventDefault();
                event.stopPropagation();
            }, true);

            function stopTrainingFiltersDrag() {
                isTrainingFiltersPointerDown = false;
                trainingFiltersContainer.classList.remove('is-dragging');

                window.setTimeout(function() {
                    isTrainingFiltersDragging = false;
                    suppressTrainingFilterClick = false;
                }, 0);
            }

            trainingFiltersContainer.addEventListener('mouseleave', stopTrainingFiltersDrag);
            window.addEventListener('mouseup', stopTrainingFiltersDrag);

            window.addEventListener('resize', function() {
                centerActiveTrainingFilter('auto');
            });

            window.requestAnimationFrame(function() {
                centerActiveTrainingFilter('auto');
            });
        }

        function updateTrainingsUrl(page, category, replaceState) {
            var state = getTrainingsState();
            var nextUrl = new URL(state.baseUrl, window.location.origin);

            if (category && category !== 'all') {
                nextUrl.searchParams.set('training-category', category);
            } else {
                nextUrl.searchParams.delete('training-category');
            }

            if (page > 1) {
                nextUrl.searchParams.set('training-page', String(page));
            } else {
                nextUrl.searchParams.delete('training-page');
            }

            var historyMethod = replaceState ? 'replaceState' : 'pushState';
            window.history[historyMethod]({
                trainingPage: page,
                trainingCategory: category
            }, '', nextUrl.toString());
        }

        function getTrainingPageFromLink(link) {
            try {
                var paginationUrl = new URL(link.href, window.location.origin);
                return parseInt(paginationUrl.searchParams.get('training-page') || '1', 10) || 1;
            } catch (error) {
                return 1;
            }
        }

        function refreshAnimations() {
            if (window.AOS && typeof window.AOS.refreshHard === 'function') {
                window.AOS.refreshHard();
            }
        }

        function fetchTrainings(page, category, options) {
            if (!trainingsListing) {
                return Promise.resolve();
            }

            var requestOptions = options || {};
            var state = getTrainingsState();
            var targetPage = Math.max(1, parseInt(page, 10) || 1);
            var targetCategory = category || 'all';
            var fallbackUrl = new URL(state.baseUrl, window.location.origin);

            if (targetCategory !== 'all') {
                fallbackUrl.searchParams.set('training-category', targetCategory);
            }

            if (targetPage > 1) {
                fallbackUrl.searchParams.set('training-page', String(targetPage));
            }

            if (!window.ajax || !window.ajax.url) {
                window.location.href = fallbackUrl.toString();
                return Promise.resolve();
            }

            if (trainingsRequestController) {
                trainingsRequestController.abort();
            }

            trainingsRequestController = typeof AbortController === 'function' ? new AbortController() : null;

            var requestBody = new URLSearchParams();
            requestBody.append('action', 'bcu_get_trainings_archive');
            requestBody.append('training_page', String(targetPage));
            requestBody.append('training_category', targetCategory);
            requestBody.append('base_url', state.baseUrl);

            trainingsListing.setAttribute('aria-busy', 'true');
            trainingsListing.classList.add('is-loading');

            return fetch(window.ajax.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: requestBody.toString(),
                signal: trainingsRequestController ? trainingsRequestController.signal : undefined
            })
                .then(function(response) {
                    return response.json();
                })
                .then(function(payload) {
                    if (!payload || !payload.success || !payload.data || typeof payload.data.html !== 'string') {
                        throw new Error('Invalid trainings archive response');
                    }

                    trainingsListing.innerHTML = payload.data.html;
                    trainingsListing.setAttribute('data-training-page', String(targetPage));
                    trainingsListing.setAttribute('data-training-category', targetCategory);
                    updateTrainingFilters(targetCategory);
                    refreshAnimations();

                    if (requestOptions.pushState) {
                        updateTrainingsUrl(targetPage, targetCategory, false);
                    }
                })
                .catch(function(error) {
                    if (error && error.name === 'AbortError') {
                        return;
                    }

                    window.location.href = fallbackUrl.toString();
                })
                .finally(function() {
                    trainingsListing.removeAttribute('aria-busy');
                    trainingsListing.classList.remove('is-loading');
                });
        }

        document.addEventListener('click', function(event) {
            var modalTrigger = event.target.closest('.js-training-modal-trigger');

            if (modalTrigger) {
                event.preventDefault();
                openTrainingModal(modalTrigger);
                return;
            }

            var modalClose = event.target.closest('.js-training-modal-close');

            if (modalClose) {
                event.preventDefault();
                closeTrainingModal();
                return;
            }

            var trainingFilter = event.target.closest('.js-training-filter');

            if (trainingFilter && trainingsListing) {
                event.preventDefault();

                var selectedFilter = trainingFilter.getAttribute('data-training-filter') || 'all';
                var currentState = getTrainingsState();

                if (currentState.category === selectedFilter && currentState.page === 1) {
                    updateTrainingFilters(selectedFilter);
                    return;
                }

                updateTrainingFilters(selectedFilter);
                fetchTrainings(1, selectedFilter, { pushState: true });
                return;
            }

            var paginationLink = event.target.closest('.js-trainings-listing .page-numbers a');

            if (paginationLink && trainingsListing) {
                event.preventDefault();
                fetchTrainings(getTrainingPageFromLink(paginationLink), getTrainingsState().category, { pushState: true });
            }
        });

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && trainingModal && !trainingModal.hidden) {
                closeTrainingModal();
            }
        });

        if (trainingsListing) {
            updateTrainingFilters(getTrainingsState().category);
            updateTrainingsUrl(getTrainingsState().page, getTrainingsState().category, true);

            window.addEventListener('popstate', function() {
                var currentUrl = new URL(window.location.href);
                var targetCategory = currentUrl.searchParams.get('training-category') || 'all';
                var targetPage = parseInt(currentUrl.searchParams.get('training-page') || '1', 10) || 1;

                updateTrainingFilters(targetCategory);
                fetchTrainings(targetPage, targetCategory, { pushState: false });
            });
        }

        initTrainingFiltersInteraction();

        if (window.Swiper && document.querySelector('.js-trainings-carousel')) {
            new window.Swiper('.js-trainings-carousel', {
                slidesPerView: 1.15,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.trainings-carousel__next',
                    prevEl: '.trainings-carousel__prev'
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    }
                }
            });
        }
    });
})(jQuery);